<template>
  <div
    class="sb-toolbar"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SbToolbar',
};
</script>

<style lang="scss">
@import '@src/layout/Toolbar/style/sb-toolbar.scss';
</style>
